// @ts-nocheck
/* eslint-disable */
export const arrowOutlineDownIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="m8 8.781 3.3-3.3.943.943L8 10.667 3.757 6.424l.943-.943z"/></svg>`,
    name: 'arrow-outline-down' as const
};